import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import './Login.css'; // Reuse Login styles
import { apiFetch } from '../api/api'; // Import your helper

function ResetPassword() {
  const { token } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setError("");
    try {
      const data = await apiFetch('/api/reset-password', {
        method: "POST",
        body: JSON.stringify({ token, newPassword }),
      });
      setMsg(data.message);
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(err.message || "Network error");
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Reset Password</h2>
        <input
          type="password"
          placeholder="New password"
          value={newPassword}
          onChange={e => setNewPassword(e.target.value)}
          required
        />
        <button type="submit">Reset Password</button>
        {msg && <div style={{ color: "green" }}>{msg}</div>}
        {error && <div className="error">{error}</div>}
      </form>
    </div>
  );
}

export default ResetPassword;